module.exports = __webpack_public_path__ + "media/src/images/icon/fa-arrow-left-53c570d700adaf1676942e4a85d63aab.gif";